import { init } from '@dash0/sdk-web'
import { environment } from '@/config'
const dash0Enabled = import.meta.env.VITE_DASH0_ENABLED === 'true'

if (dash0Enabled) {
  init({
    serviceName: 'storyfront',
    serviceVersion: import.meta.env.VITE_SENTRY_RELEASE,
    endpoint: {
      url: 'https://ingress.eu-west-1.aws.dash0.com',
      authToken: import.meta.env.VITE_DASH0_AUTH_TOKEN,
      dataset: 'prd-storyblok',
    },
    environment: environment(),
    propagators: [
      {
        type: 'traceparent',
        match: [/^https:\/\/api\.storyblok\.com.*/],
      },
    ],
    ignoreUrls: [/^(?!https:\/\/(api|app)\.storyblok\.com).*/],
  })
}
